import Vue from 'vue'
import VueRouter from 'vue-router'
import { hasToken } from '@/utils/auth'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/login' },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录', guest: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue'),
    meta: { title: '注册', guest: true }
  },
  {
    path: '/apply',
    name: 'Apply',
    component: () => import('@/views/Apply.vue'),
    meta: { title: '会员申请', requiresAuth: true }
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { title: '会员首页', requiresAuth: true }
  },
  {
    path: '/apply-info',
    name: 'ApplyInfo',
    component: () => import('@/views/ApplyInfo.vue'),
    meta: { title: '申请信息', requiresAuth: true }
  },
  {
    path: '/security',
    name: 'Security',
    component: () => import('@/views/Security.vue'),
    meta: { title: '安全中心', requiresAuth: true }
  },
  {
    path: '/notice-detail',
    name: 'NoticeDetail',
    component: () => import('@/views/NoticeDetail.vue'),
    meta: { title: '通知详情', requiresAuth: true }
  },
  {
    path: '/certificate-view',
    name: 'CertificateView',
    component: () => import('@/views/CertificateView.vue'),
    meta: { title: '电子会员证', requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
    ? `${to.meta.title} - 世界华人医师协会`
    : '世界华人医师协会 - 会员系统'

  const loggedIn = hasToken()

  if (to.meta.requiresAuth && !loggedIn) {
    next({ path: '/login', replace: true })
    return
  }

  if (to.meta.guest && loggedIn && (to.path === '/login' || to.path === '/register')) {
    next({ path: '/home', replace: true })
    return
  }

  next()
})

export default router
